import NoData from "../../components/common/NoData";
import TextNavBackground from "../../components/common/TextNavBackground";
import PlayerProfileCard from "../../components/elements/players/PlayerProfileCard";
import { apiWrapper } from "../../utils/api/apiWrapper";
import { kKotokoPlayersLegendsListURL } from "../../utils/constants/apiUrls";
import { GUEST_TOKEN } from "../../utils/constants/names";
import { ONE_MONTH_REFRESH_INTERVAL_SECONDS } from "../../utils/constants/numbers";
import { LEGEND_LIST_URL } from "../../utils/constants/websiteUrls";
import { customStaticSeoConfig } from "../../utils/helpers/helpers";

const LegendList = ({ players }) => {
  return (
    <>
      {customStaticSeoConfig("Asante Kotoko Legends")}

      <TextNavBackground title={"Legends"} />

      {players.goalkeepers.length === 0 &&
        players.defenders.length === 0 &&
        players.midfielders.length === 0 &&
        players.attackers.length === 0 && <NoData />}

      <div className="mt-10 max-w-2xl mx-auto lg:max-w-7xl lg:px-8 px-6">
        {/** GOALKEEPERS */}
        {players.goalkeepers.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Goalkeepers
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {players.goalkeepers.map((player) => (
                <a
                  key={player.id}
                  href={`${LEGEND_LIST_URL}/${player.slug}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}

        {/** DEFENDERS */}
        {players.defenders.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Defenders
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {players.defenders.map((player) => (
                <a
                  key={player.id}
                  href={`${LEGEND_LIST_URL}/${player.slug}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}

        {/** MIDFIELDERS */}
        {players.midfielders.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Midfielders
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {players.midfielders.map((player) => (
                <a
                  key={player.id}
                  href={`${LEGEND_LIST_URL}/${player.slug}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}

        {/** ATTACKERS */}
        {players.attackers.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Attackers
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {players.attackers.map((player) => (
                <a
                  key={player.id}
                  href={`${LEGEND_LIST_URL}/${player.slug}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LegendList;

export const getStaticProps = async (context) => {
  const token = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const players = await apiWrapper.get(kKotokoPlayersLegendsListURL, token);

  return {
    props: {
      players: players?.data,
    },
    revalidate: ONE_MONTH_REFRESH_INTERVAL_SECONDS,
  };
};
